// Targeting rule evaluators. See docs/04 §4.2.1 (Targeting 8 rules) and
// docs/05-combat-sim §5.6.
import { distance } from './types.js';
/** Pick the enemy that satisfies the rule. Returns null if no enemies remain. */
export function pickTarget(self, state, rule) {
    const enemies = state.entities.filter((e) => e.side !== self.side && e.hp > 0);
    if (enemies.length === 0)
        return null;
    switch (rule) {
        case 'target_nearest':
            return pickBy(enemies, (e) => distance(self.pos, e.pos), 'min');
        case 'target_farthest':
            return pickBy(enemies, (e) => distance(self.pos, e.pos), 'max');
        case 'target_lowest_hp':
            return pickBy(enemies, (e) => e.hp, 'min');
        case 'target_lowest_hp_pct':
            return pickBy(enemies, (e) => e.hp / e.hpMax, 'min');
        case 'target_highest_hp':
            return pickBy(enemies, (e) => e.hp, 'max');
        case 'target_highest_threat':
            // Threat = how much THIS entity is "owed" by each enemy. We approximate
            // it as enemy.threatMod for the simulator's MVP. Step 7 will add proper
            // threat tracking per (attacker, target) pair.
            return pickBy(enemies, (e) => e.threatMod, 'max');
        case 'target_attacker': {
            const attackerId = state.recentAttackers.get(self.id);
            const attacker = attackerId !== undefined ? enemies.find((e) => e.id === attackerId) : undefined;
            // Fall back to nearest if no attacker info / attacker dead.
            return attacker ? attacker.id : pickBy(enemies, (e) => distance(self.pos, e.pos), 'min');
        }
        case 'target_afflicted': {
            const afflicted = enemies.filter((e) => e.debuffs.length > 0);
            if (afflicted.length > 0) {
                return pickBy(afflicted, (e) => distance(self.pos, e.pos), 'min');
            }
            return pickBy(enemies, (e) => distance(self.pos, e.pos), 'min');
        }
    }
}
function pickBy(list, score, mode) {
    if (list.length === 0)
        return null;
    let bestId = list[0].id;
    let bestScore = score(list[0]);
    for (let i = 1; i < list.length; i++) {
        const s = score(list[i]);
        if (mode === 'min' ? s < bestScore : s > bestScore) {
            bestScore = s;
            bestId = list[i].id;
        }
    }
    return bestId;
}
//# sourceMappingURL=targeting.js.map